"use client";

import Link from "next/link";
import HelpGuide from "@/components/Site/HelpGuide";
import { Button, PageHeader } from "@/components/Invoice/ui";

export default function HelpPage() {
  return (
    <div>
      <PageHeader
        eyebrow={`Help · v${process.env.NEXT_PUBLIC_APP_VERSION}`}
        title="Help & guide"
        subtitle="How to use every part of the tool, with screenshots – including connecting Google Drive."
        actions={
          <Link href="/invoice/settings?tab=data">
            <Button variant="secondary">Google Drive settings</Button>
          </Link>
        }
      />
      <HelpGuide inApp />
    </div>
  );
}
